/**
 * Санитизация HTML ответа бота (только для клиентского рендера).
 */
export function sanitizeAiChatHtml(html) {
  if (typeof window === 'undefined' || !html) {
    return ''
  }

  const parser = new DOMParser()
  const doc = parser.parseFromString(String(html), 'text/html')
  const blockedTags = new Set(['script', 'style', 'iframe', 'object', 'embed', 'link', 'meta'])

  doc.body.querySelectorAll('*').forEach((node) => {
    const tagName = node.tagName.toLowerCase()
    if (blockedTags.has(tagName)) {
      node.remove()
      return
    }

    Array.from(node.attributes).forEach((attr) => {
      const name = attr.name.toLowerCase()
      if (name.startsWith('on') || name === 'style') {
        node.removeAttribute(attr.name)
      }
      if (['href', 'src'].includes(name)) {
        const value = String(attr.value || '').trim().toLowerCase()
        if (value.startsWith('javascript:') || value.startsWith('data:')) {
          node.removeAttribute(attr.name)
        }
      }
    })
  })

  return doc.body.innerHTML
}
